module.exports = __webpack_public_path__ + "img/search.6f7d28af.svg";